
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Swipeout from 'vux/src/components/swipeout/swipeout.vue'
import SwipeoutItem from 'vux/src/components/swipeout/swipeout-item.vue'
import SwipeoutButton from 'vux/src/components/swipeout/swipeout-button.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Group from 'vux/src/components/group/index.vue'

import XTextarea from "../../../node_modules/vux/src/components/x-textarea/index.vue";

export default {
components: {
XTextarea,
TransferDom,
XHeader,
XButton,
Popup,
Swipeout, SwipeoutItem, SwipeoutButton,
XAddress,
XInput,
XSwitch,
Group
},
data() {
return {
limitNumber: 999,
action: 'add',
addressList: [],

showAddressList: false,

showEditAddress: false,
formAddress: this.formAddressInitData(),
addressData: [],
}
},
created: function () {
this.handleAddressList()
},
methods: {

formAddressInitData() {
return {
name: '',
tel: '',
pcr: [],
street: '',
is_default: false
}
},
handleAddressList() {
this.$vux.loading.show({
text:'加载中'
})
const url = this.tianYiWebUrl + '/wechat/address/ajaxLists'
this.$http.get(url).then(v => {
this.addressList = v.data
console.log(this.addressList)
this.showAddressList = true;
this.$vux.loading.hide()
})
},

addAddress() {
this.action = 'add'

this.formAddress = this.formAddressInitData();

this.$vux.loading.show({
text:'区域信息加载中'
});
const url = this.tianYiWebUrl + '/wechat/address/ajaxGetChinaCity';
this.$http.get(url).then(r => {
this.addressData = r.data;
this.showEditAddress = true;
this.$vux.loading.hide()
})
},
postAddress() {
if (
this.formAddress['name'] === '' ||
this.formAddress['pcr'] === [] ||
this.formAddress['pcr'].length < 3 ||
this.formAddress['street'] === '' ||
this.formAddress['tel'] === '' ||
this.formAddress['zip'] === ''
){
this.$vux.toast.show({text:'所有内容必须填写',type:'cancel'});
return;
}
const url = this.tianYiWebUrl + '/wechat/address/ajaxPostAddress';
this.$http.post(url, this.formAddress).then(r => {
if (r.data.code === 200) {
if (this.action === 'add') {

this.addressList = [...this.addressList, r.data.data]
this.formAddress = this.formAddressInitData();
}
if (this.action === 'edit') {

this.addressList[this.actionIndex] = r.data.data
}
this.showEditAddress = false
}
})
},

onButtonClick(action, item, index) {
if (action === 'edit') {
this.$vux.loading.show({
text:'加载中'
})
this.action = 'edit'
this.actionIndex = index
const url = this.tianYiWebUrl + '/wechat/address/ajaxGetChinaCity';
this.$http.get(url).then(r => {
this.addressData = r.data;
this.formAddress = item;
this.formAddress['pcr'] = [item['provence_id'] + '', item['city_id'] + '', item['region_id'] + ''];
this.$vux.loading.hide();
this.showEditAddress = true
console.log(this.formAddress)
});
}
if (action === 'delete') {
var _self = this;
this.$vux.confirm.show({
title: '是否删除此地址',
onShow() {
},
onHide() {
},
onCancel() {
},
onConfirm() {

_self.$vux.loading.show({
text: '处理中'
});

const url = _self.tianYiWebUrl + '/wechat/address/ajaxDeleteAddress';
_self.$http.post(url, {id: item['id']}).then(r => {
_self.addressList.splice(index, 1);


_self.$vux.loading.hide()
})
}
});
}
},
}
}



// WEBPACK FOOTER //
// ./src/components/uc/Address.vue